var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('serchtable',{attrs:{"tableData":_vm.tableData,"tagList":_vm.tagList,"tag":_vm.tag},on:{"onChange":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }